module.exports = __webpack_public_path__ + "img/bg2.d3c618e5.png";